import { Button, Col, Row, Table, Typography } from "antd";
import { FaEdit } from "react-icons/fa";
import Title from "antd/es/typography/Title";
import { ModalFormMembro } from "./components/ModalFormMembro";
import { ModalImagem } from "../Noticias/components/ModalImagem";
import useMembros from "./useMembros";
import Loading from "../../components/Loading";

export default function Membros() {

    const {
        dataEntity,
        userCan,
        setIsEditarMembro,
        formMembro,
        setFotoMembro,
        showModalMembro,
        columnsMembros,
        membros,
        theme,
        refContagemDoFiltroMembros,
        isLoading,
        isModalMembroOpen,
        handleMembroCancel,
        refFormMembro,
        beforeUploadMembro,
        onClickBotaoSalvarMembro,
        isEditarMembro,
        fotoMembro,
        isModalImagemOpen,
        setIsModalImagemOpen,
        imagemModal,
    } = useMembros();

    if (!dataEntity?.entity?.id) {
        return (
            <>
                <Title level={3}>Cadastre o institucional antes de inserir os membros.</Title>
            </>
        );
    }

    if (!userCan('manage_member')) {
        return (
            <>
                <Title level={3}>Você não tem permissão para acessar essa página.</Title>
            </>
        );
    }

    return (
        <Loading loading={isLoading}>
            <Title level={3}>Membros</Title>
            <Row style={{ marginTop: 10 }}>
                <Col
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Button
                        type="primary"
                        onClick={() => {
                            setIsEditarMembro(false);
                            formMembro.setFieldsValue({
                                idMembro: "",
                                nomeMembro: "",
                                descricaoMembro: "",
                                cargoMembro: "",
                                mandatoMembro: "",
                                ordemMembro: "",
                                fotoMembro: " ",
                            });

                            setFotoMembro(" ");
                            showModalMembro();
                        }}
                    >
                        <FaEdit />
                        Adicionar Membro
                    </Button>
                </Col>
            </Row>
            <div style={{ overflowX: "auto" }}>
                <Table
                    style={{
                        // marginTop: 50
                    }}
                    columns={columnsMembros}
                    dataSource={membros.map((membro: any) => {
                        return {
                            ...membro,
                            key: membro.uuid,
                        };
                    })}
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor:
                                        theme === "light"
                                            ? "#FAFAFA"
                                            : "#1D1D1D",
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5,
                                }}
                            >
                                <Typography>
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltroMembros
                                            .current.length === 0
                                            ? membros.length
                                            : refContagemDoFiltroMembros
                                                .current.length
                                        } num total de ${membros.length
                                        } `}
                                </Typography>
                            </div>
                        );
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: "end",
                                }}
                            >
                                <Typography>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltroMembros
                                            .current.length === 0
                                            ? membros.length
                                            : refContagemDoFiltroMembros
                                                .current.length
                                        } num total de ${membros.length
                                        } `}
                                </Typography>
                            </div>
                        );
                    }}
                    pagination={{
                        locale: { items_per_page: "" },
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        position: ["topRight", "bottomRight"],
                        pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                    // rowSelection={rowSelection}
                    // loading={isLoading}
                    key={membros.uuid}
                >

                </Table>
            </div>

            <ModalFormMembro
                isModalMembroOpen={isModalMembroOpen}
                handleMembroCancel={handleMembroCancel}
                formMembro={formMembro}
                refFormMembro={refFormMembro}
                beforeUploadMembro={beforeUploadMembro}
                onClickBotaoSalvarMembro={onClickBotaoSalvarMembro}
                loadingPage={isLoading}
                isEditarMembro={isEditarMembro}
                fotoMembro={fotoMembro}
            />

            <ModalImagem
                isOpen={isModalImagemOpen}
                handleCancel={() => {
                    setIsModalImagemOpen(false);
                }}
                srcImage={imagemModal}
            />
        </Loading>
    );
}
